import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import Trans from 'next-translate/Trans'
import { Link } from 'components/Link'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { CollapsibleMenu } from 'features/components/CollapsibleMenu'
import { TabContentRoot, Answer } from './TabContent.styles'
import { FaqsType } from 'features/Faqs/Faqs'

type TabContentOwnProps = ComponentProps<typeof TabContentRoot>
export type TabContentProps = TabContentOwnProps & {
  title: string
  faqs: FaqsType[]
}

export const TabContent = ({ title, faqs }: TabContentProps) => {
  const { t } = useTranslation()

  return (
    <TabContentRoot>
      <Stack direction="column" gap="2">
        <Text size="h4" as="h3" weight="bold" color="accent-black">
          {title}
        </Text>
        <Stack direction="column" gap={{ '@initial': '1', '@bp2': '2' }}>
          {faqs.map(({ question, answer, link }, index) => (
            <CollapsibleMenu key={index} label={t(question)} hasMaxWidth={false}>
              {link ? (
                <Answer>
                  <Trans i18nKey={answer} components={[<Link href={link} key="0" />]} />
                </Answer>
              ) : (
                <Answer>
                  <Trans
                    i18nKey={answer}
                    components={{
                      p: <p />,
                      bold: <strong />,
                      email: <Link href="mailto:hello@wefeedraw.com" />,
                    }}
                  />
                </Answer>
              )}
            </CollapsibleMenu>
          ))}
        </Stack>
      </Stack>
    </TabContentRoot>
  )
}

TabContent.displayName = 'TabContent'
